module.exports = __webpack_public_path__ + "img/MOUSTACHES SET 1 PURPLE.04318fe.svg";